module.exports = __webpack_public_path__ + "img/trebel_footer_logo.3f35831.png";